module.exports = __webpack_public_path__ + "img/mi-newspaper.b1e200a2.svg";